import BaseModel from '@/shared/models/BaseModel';

export interface AbsenceTypeId {__absenceTypeId: number}

export default class AbsenceType extends BaseModel<AbsenceTypeId> {
  description = '';
  isActive = false;
}